import PropTypes from 'prop-types'
import Label from 'components/Label'
import Chip from 'components/Chip'
import Stack from '@mui/material/Stack'

const LABELS = {
  from: 'From:',
  to: 'To:',
}

const AccountMenuItem = ({
  label,
  institution,
  sub_type,
  name,
  ...props
}) =>
  <Stack
    sx={theme => theme.internalMixins.columns({ gap: .5 })}
    {...props}
  >
    <Label
      className="menu-hide"
    >
      {LABELS[label]}
    </Label>

    {institution?.name || name || 'Account'}
    {sub_type && (
      <Chip
        className="menu-hide"
        variant="success"
        size="short"
        duoTone
        font="labelSubAtomicMedium"
      >
        {sub_type}
      </Chip>
    )}
  </Stack>

AccountMenuItem.propTypes = {
  label: PropTypes.oneOf(['from', 'to']),
}

AccountMenuItem.defaultProps = {
  label: 'from',
}

export default AccountMenuItem